import CartService from '../service/CartService';

class CustomDropdown extends React.Component {
    constructor(props) {
        super(props);

        /* PREVIOUS SELECTED VALUE */
        let trainingCourseSelected = CartService.getCartItem(this.props.index).others.training_courses ? 
                                       JSON.parse(CartService.getCartItem(this.props.index).others.training_courses) : '';
        let prevSelectedValue      = '';
        Object.keys(trainingCourseSelected).map((key) => {
            if (this.props.courseId && trainingCourseSelected[key].id == this.props.courseId && trainingCourseSelected[key].selected_event)
            {
                prevSelectedValue = this.props.courseId + '_' + trainingCourseSelected[key].selected_event;
            }
        })
        
        let prevOptions = this.props.options;
        let prevSelectedValueDetail = ''
        for (let index = 0; index < prevOptions.length; index++) {
            const element = prevOptions[index];
            if (element.value === prevSelectedValue) {
                prevSelectedValueDetail = element
            }
        }
        /* PREVIOUS SELECTED VALUE */
        
        this.state = {
            isOpen: false,
            selectedValue: prevSelectedValue ? prevSelectedValue : '',
            selectedValueDetail: prevSelectedValueDetail ? prevSelectedValueDetail : ''
        };
        this.dropdownRef = React.createRef();
    }

    handleToggleDropdown = () => {
        this.setState(prevState => ({
            isOpen: !prevState.isOpen
        }));
    };

    handleSelectOption = (value) => {
        this.selectEventModifier(value);
        this.setState({
            selectedValue: value,
            isOpen: false
        });

        let options = this.props.options;
        for (let index = 0; index < options.length; index++) {
            const element = options[index];
            if (element.value === value) {
                this.setState({
                    selectedValueDetail: element
                })
            }
        }
    };

    handleClickOutside = (event) => {
        if (this.dropdownRef.current && !this.dropdownRef.current.contains(event.target)) {
            this.setState({ isOpen: false });
        }
    };

    selectEventModifier = (value) => {
        const cartList = CartService.getCart();
        const cart     = CartService.getCartItem(this.props.index);
        const selectedTrainingCourseEvent = cart.others.training_courses ? JSON.parse(cart.others.training_courses) : '';
        
        const numString = value;
        // Locate the underscore
        const underscoreIndex = numString.indexOf('_');
        // Split the string into two parts using the position of the underscore
        const firstPart  = parseInt(numString.substring(0, underscoreIndex));
        const secondPart = parseInt(numString.substring(underscoreIndex + 1));

        Object.keys(selectedTrainingCourseEvent).map((key) => {
            if (selectedTrainingCourseEvent[key].id == firstPart)
            {
                selectedTrainingCourseEvent[key].selected_event = secondPart
            }
        })

        cartList[this.props.index].others.training_courses = JSON.stringify(selectedTrainingCourseEvent);
        
        localStorage.setItem("mycart", JSON.stringify(cartList));
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    render() {
        const { label, options, className } = this.props;
        const { isOpen, selectedValue, selectedValueDetail } = this.state;
        
        return (
            <div className={`myk-dropdown-container ${className || ''}`} ref={this.dropdownRef}>
                {(options.length > 0 ?
                <div className="myk-dropdown-input" onClick={this.handleToggleDropdown}>
                    <input
                        type="text"
                        readOnly
                        value={selectedValue ? options.find(opt => opt.value === selectedValue).label : ''}
                        placeholder={label}
                        className={`myk-dropdown-placeholder ${selectedValue ? 'filled' : ''}`}
                    />
                    <label>{label}</label>
                    <div class="caret-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="6.119" height="11.658" viewBox="0 0 6.119 11.658"><path id="Path_21616" data-name="Path 21616" d="M0,0,4.42,3.71,8.84,0" transform="translate(1.409 10.249) rotate(-90)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path></svg>
                    </div>
                </div>
                :
                <span class="badge mk-badge-expired">No Events Available</span>)
                }
            
                {isOpen && (
                    <div className="myk-custom-dropdown-menu">
                        {options.map(option => (
                            <div key={option.value} className="myk-custom-dropdown-item" onClick={() => this.handleSelectOption(option.value)}>
                                {option.label}
                            </div>
                        ))}
                    </div>
                )}
                {selectedValue && selectedValueDetail ? 
                <div class="cart-training-event-desc mt-4">
                    <div class="mb-1 icon-teacher-expiry d-flex align-items-center gap-1">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-clock"><path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z"></path><path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z"></path></svg>
                        <p class="p-0 m-0 d-inline-flex gap-1 mk-flex-one">{selectedValueDetail.date}</p>
                    </div>
                    <div class="mb-1 icon-teacher-expiry d-flex align-items-center gap-1">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-geo-alt" viewBox="0 0 16 16"><path d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A31.493 31.493 0 018 14.58a31.481 31.481 0 01-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0110 0c0 .862-.305 1.867-.834 2.94zM8 16s6-5.686 6-10A6 6 0 002 6c0 4.314 6 10 6 10z"></path><path d="M8 8a2 2 0 110-4 2 2 0 010 4zm0 1a3 3 0 100-6 3 3 0 000 6z"></path></svg>
                        <p class="p-0 m-0 d-inline-flex gap-1 mk-flex-one">{selectedValueDetail.venue}</p>
                    </div>
                    <span class="badge mk-badge-expired">{selectedValueDetail.seats} seats left</span>
                </div>
                : '' }
            </div>
        );
    }
}

export default CustomDropdown;


